import { useCallback, useEffect, useMemo, useState } from "react";
import { fetchAllAgencies } from "services/services.projects";
import { getFormattedOptions } from "utility/helpers";

const useAgencies = (dateRange) => {
  const [agencies, setAgencies] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const refetch = useCallback(() => {
    setIsLoading(true);

    fetchAllAgencies({
      dateRange,
      callback: (data) => {
        setAgencies(data);
        setIsLoading(false);
      },
    });
  }, [dateRange]);

  const nameOptions = useMemo(() => {
    return getFormattedOptions("name", agencies);
  }, [agencies]);

  const acronymOptions = useMemo(() => {
    return getFormattedOptions("acronym", agencies);
  }, [agencies]);

  useEffect(() => {
    refetch();
  }, [refetch]);

  return {
    nameOptions,
    acronymOptions,
    data: agencies,
    isLoading,
    refetch,
  };
};

export default useAgencies;
